// extracted by mini-css-extract-plugin
module.exports = {"divider":"WordPractice_divider__I2myG","wordsContainer":"WordPractice_wordsContainer__10LY-","word":"WordPractice_word__3DGtU"};